import * as React from "react";

function SvgPlanetEarth(props) {
  return (
    <svg viewBox="0 0 120 120.07" {...props}>
      <defs>
        <filter
          id="planet-earth_svg__a"
          x={6.94}
          y={-8214.39}
          width={71.38}
          height={32766}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodColor="#fff" result="bg" />
          <feBlend in="SourceGraphic" in2="bg" />
        </filter>
        <filter
          id="planet-earth_svg__c"
          x={6.94}
          y={7.12}
          width={71.38}
          height={70.67}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodColor="#fff" result="bg" />
          <feBlend in="SourceGraphic" in2="bg" />
        </filter>
        <radialGradient
          id="planet-earth_svg__d"
          cx={-14.95}
          cy={-315.83}
          r={66.25}
          gradientTransform="matrix(.03 -.87 .9 -.16 310.31 -35.58)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.23} stopColor="#f4f4f4" />
          <stop offset={0.67} stopColor="#515151" />
          <stop offset={1} />
        </radialGradient>
        <mask
          id="planet-earth_svg__e"
          x={6.94}
          y={7.12}
          width={71.38}
          height={70.67}
          maskUnits="userSpaceOnUse"
        >
          <g
            mask="url(#planet-earth_svg__b)"
            filter="url(#planet-earth_svg__c)"
          >
            <path
              d="M20.87 19.8C36 5.26 60.19 2.44 72.86 15.46S74 40.23 59.55 58.2c-11.89 14.8-32.32 27.12-45 14.1s-8.81-37.96 6.32-52.5z"
              style={{
                mixBlendMode: "multiply",
              }}
              fill="url(#planet-earth_svg__d)"
            />
          </g>
        </mask>
      </defs>
      <g data-name="Layer 2">
        <circle cx={60} cy={60} r={60} fill="#4fdbc3" />
        <path
          d="M14.76 20.7a49.48 49.48 0 11-3.19 4 60.17 60.17 0 103.19-4z"
          fill="#4fcdc0"
        />
        <path
          d="M100.84 16.15c-.26-.25-.37 0-.64-.24a62.38 62.38 0 01-7.34 75.36 62.67 62.67 0 01-72.7 13.53 59.75 59.75 0 0039.51 15.13H62.28a59.92 59.92 0 0038.56-103.78z"
          fill="#3faeb4"
        />
        <path
          d="M79.05 107a1.28 1.28 0 011.06-.56c.29-.33.59-.65.86-1a24.74 24.74 0 004.64-8.54A16.75 16.75 0 0074.51 85a8.31 8.31 0 00-5.21-.17 4.26 4.26 0 00-3 4c.1 1.76 2.09 3.28 3.71 2.57a14.11 14.11 0 01-14.2 6.5c-.72.69-.42 1.91.13 2.75a6 6 0 011.37 2.61c.09 1.41-1.34 2.55-2.75 2.67a8.36 8.36 0 01-4.06-1.1 12 12 0 01.59 13.89h.29a1.58 1.58 0 01.87-.27 12.62 12.62 0 006.37-1.63 1.5 1.5 0 012.18.69l1.47-.38a1.61 1.61 0 011.4-1.06c5.66-.53 11.98-4.74 15.38-9.07z"
          fill="#20968f"
        />
        <path
          d="M79.26 7.05a14.33 14.33 0 00-6.76-.43c-1.64.29-3.46 1.12-3.8 2.75s1 3.05 2.44 3.63a15.68 15.68 0 004.7.61 20.14 20.14 0 0114.51 7.84c.94 1.24 2 2.74 3.52 2.86 2 .17 3.44-2.37 2.93-4.35s-2.21-3.41-3.86-4.62C87.73 11.48 85.46 9 79.26 7.05z"
          fill="#75e33c"
        />
        <path
          d="M74.77 14.25c4.25.46 8.84 1.08 11.86 4.08a33.53 33.53 0 012.72 3.45 8.3 8.3 0 003.32 2.8 3.75 3.75 0 004.08-.7 2.46 2.46 0 00-.51-3.74c-.32 1.67-2.61 2.24-4.16 1.53s-2.54-2.21-3.66-3.5a19.08 19.08 0 00-18.26-6c.84 1.52 2.84 1.89 4.61 2.08z"
          fill="#20968f"
        />
        <ellipse
          cx={54.29}
          cy={48.47}
          rx={30.39}
          ry={24.01}
          transform="rotate(-29.95 54.296 48.474)"
          fill="#43fac8"
        />
        <path
          d="M60.55 26.18c.32-1.5 1.67-2.53 3-3.28a11.7 11.7 0 003.75-2.59c1-1.2 1.08-3.22-.18-4.08a5.3 5.3 0 011.29 8.85c-1 .87-2.31 1.34-3.3 2.23s-1.55 2.54-.66 3.52a8.76 8.76 0 001.36 1c1.42 1.09 1.44 3.17 1.47 5s.44 4 2.12 4.57a5.15 5.15 0 01-5.06-3.84c-.28-1.16-1.41-2.66-1.7-3.81-.73-2.87-2.71-4.75-2.09-7.57zM88.3 81.44c1-1.1 2.81-.62 4.31-.68 4-.15 6.42-4.4 8-8.08q2.79-6.42 5.6-12.83a1.33 1.33 0 012.52.77 29.46 29.46 0 01-7.16 14.57 4.55 4.55 0 00-1.19 2.31c-.46 3.2 3.1 3.7 4.9 2.26a1.71 1.71 0 012.83 1.16l.06 1.16a42.38 42.38 0 006.9-12.28 1.73 1.73 0 013.33.86 45.58 45.58 0 01-2 8.08c-2.09 6.31-5.09 12.43-9.63 17.3s-10.75 8.38-17.4 8.77-13.62-2.7-17-8.42C70.79 93.54 70 90 71.32 87s5-5 8-3.74c1.33.56 2.36 1.65 3.63 2.33s3.08.83 4-.31.42-2.83 1.35-3.84zM17.18 65.85a29.29 29.29 0 0012.06 22.63c3.53 2.52 8 4.76 8.9 9 .28 1.33.19 2.83 1 3.9a5.45 5.45 0 003.46 1.53c3.92.69 8.5 1.19 11.36-1.57 1.22-1.18 2-2.86 3.49-3.65 2.05-1.07 5.15-.3 6.24-2.5a2.94 2.94 0 000-2.38c-.91-2.34-3.48-3.34-4.66-5.42s-.68-4.73.6-6.71a11.77 11.77 0 011.68-2 2.94 2.94 0 00-1.41-5 10.82 10.82 0 00-7.07 1.06c-2.26 1.23-4.36 3.37-7.06 2.52a4.66 4.66 0 01-3.08-4c-.35-3.2 1.62-5.86 3.78-8-3.9 1.89-8.95 4.16-13.22 4.92s-9 .26-12.43-2.35c-1.63-1.38-1.55-1.6-3.64-1.98z"
          fill="#20968f"
        />
        <path
          d="M94.23 54.46c-3 2.3-7.15 2-10.91 1.64-8.67-.78-17.65-1-25.81 2s-15.36 10-16.37 18.62c.12-8.43 6.1-16 13.63-19.82s15.12-4.56 23.51-3.67c3.68.39 8.84 1.23 12.11-.5a10.5 10.5 0 005-7 19.6 19.6 0 00-.33-8.73 29.32 29.32 0 012.5 9c.17 3.16-.83 6.54-3.33 8.46z"
          fill="#20968f"
        />
        <path
          d="M66.72 87.75l-.38-.16c.15.12.32.31.38.16zM40.28 104a36.52 36.52 0 00-8.64-3.59c-1.42.37-2.58-1.33-2.53-2.79s.8-2.81.94-4.26-.79-3.23-2.25-3.09c-1.08.1-1.77 1.2-2.12 2.24a6.3 6.3 0 01-1.4 2.9 3.19 3.19 0 01-3.89-.11 7.55 7.55 0 01-2.3-3.46A17.36 17.36 0 0016.33 88a6.66 6.66 0 00-5.23-2.73c-1 0-2.82 1.44-4.18 2.67a60.24 60.24 0 0032.23 28.27l.51.18c.57.21 1.16.4 1.74.59s1.36.43 2.05.62l.62.18c1 .27 2 .52 3 .74.55-2.29.75-5.3.09-7.06a15.17 15.17 0 00-6.88-7.46zM19.47 29.42a10.19 10.19 0 00-1.36 3.65 3.49 3.49 0 001.94 3.18c.85.4.38 1.6-.09 2.41a2.44 2.44 0 01-2.4 1.14C13.87 52.31 15.62 66.86 23 77.64a45 45 0 0032.66 19.15c.86.08 2.77.87 4-.87A1.6 1.6 0 0158 94.57a5.92 5.92 0 01.19-2.32 15 15 0 00.14-4.49 4 4 0 00-.48-1.63 1.66 1.66 0 00-1.41-.85c-.86 0-1.43.87-1.91 1.59s-1.07 1.88-1.89 1.59A2.73 2.73 0 0149.6 84c.65-.55 1.58-.82 2-1.57a2.05 2.05 0 00-1.34-2.62 5.14 5.14 0 00-3.33.1 3.33 3.33 0 01-3.7-1.66A7.19 7.19 0 0142.5 74c.65-7.49 6.14-14 12.88-17.34s14.53-4 22-3.43a60.45 60.45 0 009.5.38c3.16-.28 6.9-.84 8.26-3.71 2.66-5.61 2.29-12.72-1.51-17.64s-11-7.07-16.69-4.44A8 8 0 0072.73 32c-.67 1.78-.41 3.78-.91 5.61s-2.36 3.63-4.11 2.9C66.43 40 66 38.39 65.83 37s-.12-2.87-1-4a11.31 11.31 0 00-2.31-1.85 2.6 2.6 0 01-1.19-2.53c.27-1 1.34-1.43 2.22-1.92a8.9 8.9 0 004.28-9 5.58 5.58 0 00-2.39-3.89c-2.48-1.49-5.58 0-8.28 1A27.92 27.92 0 0128.58 9a61 61 0 00-11 8.73 10.62 10.62 0 011.89 11.69z"
          fill="#4ab70e"
        />
        <path
          d="M66.21 87.51l.16.06c-.1-.1-.18-.18-.16-.06zM102.13 17.3a13.41 13.41 0 00-1.13 1.82 4.43 4.43 0 00-.83 3.1c.45 1.79 2.73 2.22 4.41 3 4.52 2.11 6.06 8.46 10.37 10.56a60.32 60.32 0 00-12.82-18.48zM53.41 119.57a60 60 0 0062.14-36.84 5.11 5.11 0 00-1.12-.5 5.24 5.24 0 00-5 1.23 22 22 0 00-1.87 2.42 4 4 0 01-2.47 1.69 1.9 1.9 0 01-2.2-1.58c-3.27-.65-7-1.94-10.23-2.59a5.3 5.3 0 00-3.13 0c-2.26 1-2.54 4.84-6.07 3.86a6.24 6.24 0 01-2.7-1.67c-2.12-2.14-5.32-2.22-8-1.3a16 16 0 00-3.09 1.5 2.4 2.4 0 00-.67 3.49c.63.93.45 2.49-.62 2.87-.41 1-1.43 1.1-2.52 1.28a11.37 11.37 0 00-3.25.64 7.14 7.14 0 00-2.36 2.22 22.47 22.47 0 00-1.72 2.41c-1 .56-.78.79-.35 1.89s1 2.38.39 3.4a2.83 2.83 0 01-2.88 1c-1.27-.18-2.53-.7-3.81-.28a1.77 1.77 0 00-1.3 1.87c.16 1 1.27 1.4 2.09 2 2.29 1.57 2.5 4.91 1.82 7.6-.28 1.11-.7 2.25-1.08 3.39z"
          fill="#4ab70e"
        />
        <path
          d="M90 60.44c-2-.57-4 .77-5.6 2l-12.88 10c-1.56 1.21-3.31 3-2.58 4.84.51 1.28 2 1.83 3.35 2.07a17.91 17.91 0 0019.82-10.89 8.62 8.62 0 00.73-4.57A4.25 4.25 0 0090 60.44z"
          fill="#43fac8"
        />
        <path
          d="M75 36.92c-.58 2.2-3.21 3.74-2.94 6 .24 2 2.5 2.9 4.38 3.58a39.33 39.33 0 018.74 4.5c2.56 1.46 6 .09 7.69-2.35s1.83-5.6 1.46-8.53-1.24-5.67-3.38-7.5a9.16 9.16 0 00-2.64-1.53l-.26-.1c-1.81.28-3.81 1.28-5.15-1.38h-.27a10.12 10.12 0 00-3.29-.14 4.86 4.86 0 00-4.1 3.21c-.37 1.32.14 2.84-.24 4.24zM40.38 80.41a12.37 12.37 0 011.17-12.51c-1.67-.59-3.36.93-4.13 2.52-1.09 2.27-1.37 5.09-4.63 5.81a1 1 0 01-.79-.15c-2-1.43-1.2-3-.23-4 2.23-2.4 5.23-3.7 8.08-5.33s5.56-3.93 6.16-7.11c-3.07 2.45-6.2 4.94-9.84 6.43s-7.93 1.88-11.45.12a8.34 8.34 0 00-3.21-1.3 2.23 2.23 0 00-1.91 1c-.67 1 .43 3.15.73 3.81 3.13 6.86 7.5 11 13.65 16.6 3.85 3.53 10.55 7.26 16.4 4.87a1 1 0 00-.38-1.93c-6.44-.13-9.72-10.38-9.62-8.83z"
          fill="#69d824"
        />
        <path
          d="M65.48 49.08A17.44 17.44 0 0064 50.43a1.85 1.85 0 00-.4 1.86 41.07 41.07 0 0115.1-.95 2.61 2.61 0 001.18 0 .84.84 0 00.58-.91c-.09-.37-.5-.56-.86-.68-2-.64-4.13-.64-6.16-1.14s-4.12-1.69-4.71-3.7a6.85 6.85 0 00-.63-2.06c-.41-.6-1.45-.84-1.8-.21a5.34 5.34 0 01-.82 6.44z"
          fill="#75e33c"
        />
        <path
          d="M12.18 93c2.52-.53 4.55 1.9 6.35 3.74 6.41 6.57 16.57 7.83 24 13.26.87.64 1.79 1.57 1.56 2.62a2 2 0 01-1.8 1.42 5.52 5.52 0 01-2.39-.44c-9.23-3.24-17.14-9.31-24.89-15.28C13.27 97 11.35 95 12.18 93z"
          fill="#7abd24"
        />
        <path
          d="M57.25 49.55c2.64-2.4 2.14-6.65 1-10s-2.57-7.08-1.24-10.39c1.17-2.93 4.46-5.57 3.31-8.51A4.48 4.48 0 0056 18.14a14.23 14.23 0 00-5.09 1.47 27.62 27.62 0 01-9.11 2.51 11 11 0 01-8.66-3.06c-1.23-1.31-2-3-3.23-4.29s-3.21-2.2-4.8-1.38A3.89 3.89 0 0023.3 17a15.47 15.47 0 00.92 4.11 29.41 29.41 0 01-2.54 22.42c-2.41 4.25-6.06 8.87-4.39 13.47 1.35 3.72 5.87 5.51 9.8 5s7.4-2.73 10.69-4.95 6.67-4.53 10.57-5.24c3.07-.51 6.65-.15 8.9-2.26z"
          fill="#88e33d"
        />
        <path
          d="M96.64 88.54c-5.79-2.15-11.73 5.81-17.56 3.78-1.71-.6-3.25-2-5-1.79-1.59.23-2.68 1.77-3.17 3.3s-.56 3.17-1.16 4.66c-.9 2.26-2.86 3.89-4.79 5.37s-4 3-5.15 5.07-1.21 5.1.62 6.7c11.87-.85 24.09-3.31 33.66-10.39 2.78-2.06 5.4-4.66 6.31-8s-.51-7.49-3.76-8.7z"
          fill="#69bf24"
        />
        <path
          d="M53.41 119.7a60 60 0 0061.71-35.85 5.17 5.17 0 00-5 .11c-1 .64-1.68 1.65-2.69 2.19a3.85 3.85 0 01-2.35 1.55 2.11 2.11 0 01-2-.89c-3 .73-5.31 3.35-7.51 5.63a57.72 57.72 0 01-41.72 17.4c1.18 1.75 1.22 4.28.68 6.42-.32 1.16-.74 2.3-1.12 3.44z"
          fill="#3c8e31"
          opacity={0.5}
        />
        <path
          d="M98.12 67.43a20.75 20.75 0 006.52-12 42.15 42.15 0 00-.12-13.86c-.25-1.69-.55-3.38-.87-5.06-.23-1.23-.67-2.69-1.94-3A2.23 2.23 0 0099.27 35c-.6 1.51 0 3 .33 4.55a21.13 21.13 0 01-2.89 16.52 9.53 9.53 0 00-1.5 5.93 3.11 3.11 0 010 .53 23.89 23.89 0 00-.42 3.45c.1 1.15 1 2.38 2.19 2.16a2.67 2.67 0 001.14-.71z"
          fill="#43fac8"
        />
        <path
          d="M84.23 39.28a15.45 15.45 0 00-3.34-7.38 2.69 2.69 0 00-1.48-1.06c-1.08-.2-2 .9-2.16 2a9 9 0 00.56 3.22 3.76 3.76 0 01-.27 3.17c-.52.69-1.45 1.09-1.7 1.91a1.88 1.88 0 00.87 2 5.57 5.57 0 002.19.73c1.53.27 3.31.48 4.45-.57s1.1-2.61.88-4.02z"
          fill="#69d824"
        />
        <path
          d="M28.56 81a18.52 18.52 0 003.68 4.39A14.87 14.87 0 0039.42 88c.77.12 1.78.08 2.07-.65A1.23 1.23 0 0041 86a4.2 4.2 0 00-1.41-.64A17 17 0 0131 78.84C29.73 77 28.86 75 27.58 73.2a7.83 7.83 0 00-5.27-3.57c-.36 1.46.53 2.9 1.37 4.15z"
          fill="#69d224"
        />
        <path
          d="M80.58 100.6l1.34.58a4.54 4.54 0 01-2.58 1.66l-13.88 4.92c2.22-1.78 4.51-3.65 5.75-6.22.78-1.61 1.16-3.5 2.48-4.72a4.14 4.14 0 016.89 3.78z"
          fill="#69b024"
        />
        <path
          d="M57.11 70.18a15.87 15.87 0 01-6 3c-1 .24-2.42.37-2.67-.64A1.94 1.94 0 0149.1 71l.31-.37c3.23-3.75-1.39-1.19-1.64-1.51-.64-.79 5.51-8.9 16-10.77 2.09-.37 4.43-.48 6.15.77a26.42 26.42 0 00-13.14 3.63 8.62 8.62 0 00-2.62 2.14 4.32 4.32 0 00-.46.78 1.11 1.11 0 001.57 1.41c2.55-1.42 7.33-5.46 7.67-4.25.08.43 5.43-1.08.26 1.28a13 13 0 00-6.09 6.07z"
          fill="#20968f"
        />
        <path
          d="M88.43 38a.87.87 0 00.38-.67c0-.43-.4-.77-.43-1.2s.43-.9.81-1.27.66-1 .29-1.36a2.07 2.07 0 00-2.49 0 3 3 0 00-1.08 2.36 2.52 2.52 0 00.66 1.88 1.48 1.48 0 001.86.26z"
          fill="#69d824"
        />
        <path
          d="M99 24.52a7.13 7.13 0 01-6.22 1.88c0 .12-.48.22-.47.34a1.43 1.43 0 001.38.51 2.24 2.24 0 011.5.24c.5.38.49 1.12.75 1.7.7 1.51 3.12 1.64 3.71 3.2l-1-4a2.14 2.14 0 010-1.63c.2-.36.6-.57.85-.9a1.05 1.05 0 00-.5-1.34z"
          fill="#20968f"
        />
        <path
          d="M6.39 47.5a47.63 47.63 0 01.67-5.59.65.65 0 00-1.25-.32A62.18 62.18 0 002.58 60a19.71 19.71 0 00.69 6.18 1.2 1.2 0 002.34-.4 70.37 70.37 0 01.59-11.64A40.07 40.07 0 0018.47 85c-4-10-7.74-20.2-8.74-30.9-.82-8.87.47-18.2 4.76-25.91a.51.51 0 00-.84-.56A32.2 32.2 0 006.39 47.5z"
          fill="#7feddc"
        />
        <path
          d="M47.14 118.67a9.47 9.47 0 00.64-4.26 8.33 8.33 0 00-1.16-2.49 13.93 13.93 0 00-6.38-4.67c-2.47-1-5.08-1.63-7.61-2.5A39.31 39.31 0 0113 89.74a18.54 18.54 0 00-2.47-3.23 3.49 3.49 0 00-1-.56 6.91 6.91 0 00-2.65 2 58.41 58.41 0 0040.26 30.72z"
          fill="#3c8e31"
          opacity={0.5}
        />
        <path
          d="M30.47 44.12a18.75 18.75 0 00.5-3.39A2.84 2.84 0 0029.24 38c-1.24-.37-2.54.59-3.13 1.74A23.07 23.07 0 0025 43.47c-1.15 3.8-4.81 6.94-4.37 10.88a5.81 5.81 0 006.84 4.78c3-.73 4.83-3.71 7.35-5.51a9.15 9.15 0 001.77-1.38 2 2 0 00.41-2.09c-1-1.31-3.15-.59-4.67-1.24-1.67-.73-2.14-2.91-1.86-4.79z"
          fill="#69d824"
        />
        <path
          d="M47.92 37.68a9.24 9.24 0 013.15-3.52 11.41 11.41 0 003.36-3.35c.75-1.41.75-3.37-.47-4.39a4.32 4.32 0 00-3.07-.76A12.51 12.51 0 0044.21 28c-1.59 1.18-2.89 2.72-4.49 3.89s-3.68 2-5.55 1.31a10.65 10.65 0 00-2.59-.95c-.92-.06-2 .89-1.5 1.69a7.16 7.16 0 013 7 15 15 0 00-.56 3.22c.07 1.09.9 2.26 2 2.14a5 5 0 01.54-3c.59-.87 2-1.22 2.67-.39a3.07 3.07 0 01.43 1.45 6.87 6.87 0 003.69 5 4.4 4.4 0 004.11.1c1.8-1.06 2.12-3.52 1.91-5.59s-.73-4.26.05-6.19z"
          fill="#69d824"
        />
        <path
          d="M0 60a59.56 59.56 0 005.51 25.08c21.43 5.55 43.38-1.54 59.63-18.77C81.87 48.57 88 24.8 80.06 3.51A60 60 0 000 60z"
          fill="#fff"
          opacity={0.15}
        />
        <path
          d="M30 111.84c-.54-.28-1-.58-1.57-.88A59.94 59.94 0 1039 3.86a59.53 59.53 0 0147.06 3.72 58.79 58.79 0 0124.35 79.88A59.68 59.68 0 0130 111.84z"
          style={{
            mixBlendMode: "screen",
          }}
          fill="#fff"
          opacity={0.24}
        />
        <g mask="url(#planet-earth_svg__e)">
          <path
            d="M20.87 19.8C36 5.26 60.19 2.44 72.86 15.46S74 40.23 59.55 58.2c-11.89 14.8-32.32 27.12-45 14.1s-8.81-37.96 6.32-52.5z"
            fill="#f7ebc2"
            opacity={0.57}
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgPlanetEarth;
